import { Checkbox } from 'antd';
import React from 'react';
import {  useState } from "react";
import { Trans } from 'react-i18next';
import { CustomField } from '../../../pages/videoConference/types';
import { FormCheckbox, FormTerms, FormTermsText } from "./ style";

export const TermsInput = ({
  label,
  customTerms,
  color,
  ...inputProps
}: any) => {
  const [checkboxStatus, setCheckboxStatus] = useState(false);

  return (
    <FormCheckbox color={color}>
      <FormTerms>
        <Checkbox 
          required={true}
          {...inputProps}
          onClick={() => setCheckboxStatus(!checkboxStatus)}
          checked={checkboxStatus}
        >
          <FormTermsText>
            <Trans i18nKey={'formSubscribe.privacyPolicies'}>
              Concordo com os
              <a target="_blank" rel="noreferrer" href="https://docs.google.com/a/eventials.com/viewer?embedded=true&url=https://contratos.eventials.com/Eventials-Termos_Gerais_de_Uso-v1.pdf"> Termos de Uso</a> e 
              <a target="_blank" rel="noreferrer" href="https://www.eventials.com/portal-de-privacidade/"> Política de Privacidade</a>
            </Trans>
            {customTerms && customTerms.map((term: CustomField, index: number) => {
              let htmltext = term.label.replace(/\[(.+?)\]\((.+?)\)/g, `<a target="_blank" rel="noreferrer" href="$2">$1</a>`);
              return <FormTermsText style={{marginLeft: '3px'}} key={index} dangerouslySetInnerHTML={{ __html: htmltext }} />;
            })}
          </FormTermsText>
        </Checkbox>
      </FormTerms>
    </FormCheckbox>
  );
}